module.exports = __webpack_public_path__ + "img/eye.ed58d370.svg";